import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DepositFormFiller } from './form-filler.factory';
import { inject } from '@angular/core';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { UserFullInfo } from 'src/app/services/auth/login/login.models';

export class PixAstropayCard implements DepositFormFiller {
    public fillForm(form: UntypedFormGroup, userInfo: UserFullInfo) {
        console.log("PIX deposit")
        form.addControl('nationalId', new FormControl(userInfo.national_id_number,
            []));
        form.addControl('nationalIdType', new FormControl('CPF',
            []))
        return
    }
}
